<template>
  <div class="row mb-2">
    <div class="col-12">
      <z-message v-model="notice" :timeout="3000" class="alert alert-warning" />
    </div>
  </div>
  <div class="row mb-1">
    <div class="col-2"></div>
    <div class="col">
      <div class="input-group">
        <span class="input-group-text">Template</span>
        <select class="form-select" v-model="selectedTemplate">
          <option
            v-for="template of biTemplates"
            :value="template.id"
            :key="template.id"
          >
            {{ template.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-2"></div>
  </div>
  <div class="row mb-2">
    <div class="col-2 text-center">
      <span class="custom-column-label">Range</span>
    </div>
    <div class="col">
      <span class="custom-column-label">Message</span>
    </div>
  </div>
  <div v-for="range of ranges" :key="range.id" class="row mb-1">
    <div class="col-2 text-center">
      <span>{{ formatValue(range.min) }} - {{ formatValue(range.max) }}</span>
    </div>
    <div class="col custom-editor">
      <editor
        :ref="`zEditor-${range.id}`"
        contentType="html"
        :modules="modules"
        style="height: 200px; width: 100%"
        @message="showMessage"
        @focus="setIndex(range.id)"
        @textChange="editorChanged(range.id)"
        @blur="editorChanged(range.id)"
      />
      <div class="custom-canned-messages-icon">
        <i
          class="fas fa-clipboard-list"
          @click="showCannedMessages(range.id)"
        ></i>
      </div>
      <div
        v-if="isShowPrecanned && range.id === editorIdx"
        class="custom-canned-messages"
      >
        <div class="custom-canned-messages-close">
          <i class="fas fa-times" @click="isShowPrecanned = false"></i>
        </div>
        <ul class="custom-canned-messages-list">
          <li
            v-for="canned in cannedMessages"
            :key="canned.id"
            @click="setPrecanned(range.id, canned)"
          >
            {{ canned.text }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Editor from '@/Components/ZElements/Editor.vue'
import ZMessage from '@/Components/ZElements/Message'
export default {
  name: 'batch-messages',
  components: {
    Editor,
    ZMessage,
  },
  data() {
    return {
      endpoint: 'api/v2/messages/attachments',
      uploadKey: 0,
      folder: '',
      path: '',
      modules: {
        name: 'imageUploader',
        module: ImageUploader,
        options: {
          upload: this.uploader,
        },
      },
      notice: '',
      editorIdx: null,
      isShowPrecanned: false,
      cannedMessages: [],
    }
  },
  emits: ['valid', 'show', 'edited'],
  computed: {
    ...mapGetters('configuration', ['biTemplates', 'selectedBiTemplate']),
    ...mapGetters('organizations', ['examineOrganization']),
    selectedTemplate: {
      get() {
        let _data = null
        if (this.selectedBiTemplate) {
          _data = this.selectedBiTemplate.id
        }
        return _data
      },
      set(value) {
        this.setSelectedBiTemplate({
          name: 'setTemplate',
          value: null,
        })
        let found = this.biTemplates.find((template) => template.id === value)
        if (found) {
          this.setSelectedBiTemplate(found)
        }
        console.log('selectedTemplate', this.selectedBiTemplate)
      },
    },
    ranges() {
      let _data = []
      if (this.selectedBiTemplate) {
        _data = this.selectedBiTemplate.ranges
      }
      return _data
    },
    orgId() {
      let _data = null
      if (this.examineOrganization) {
        _data = this.examineOrganization.id
      }
      return _data
    },
  },
  methods: {
    ...mapActions('configuration', [
      'setSelectedBiTemplate',
      'setSelectedBiTemplateData',
    ]),
    showMessage(msg) {
      this.notice = msg
    },
    setTag(text) {
      let editor = this.$refs[`zEditor-${this.editorIdx}`]
      if (editor) {
        editor[0].insertText(text)
        this.$emit('edited')
      }
    },
    formatValue(item) {
      let value = 0
      if (item) {
        if (item !== 0 && item !== 0.0001) {
          value = Math.ceil(item)
        }
      }
      return value
    },
    uploader(file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('files[]', file)
        let api = `${location.origin}/${this.endpoint}`
        if (this.orgId !== null) {
          api += `/${this.orgId}`
        }
        axios
          .post(api, formData, {
            headers: {
              'Content-Type': `multipart/form-data;boundary=${Math.random().toString()}`,
            },
          })
          .then((res) => {
            console.log('Files Uploaded', res)
            resolve(res.data.data[0].Url)
          })
          .catch((err) => {
            reject('upload failed')
            console.error('Error:', err)
          })
      })
    },
    messageBody(idx) {
      let body = ''
      let editor = this.$refs[`zEditor-${idx}`]
      if (editor) {
        body = editor[0].getHTML()
        if (body === '' || body === '<p><br></p>') {
          body = ''
        }
      }
      return body
    },
    setIndex(idx) {
      this.editorIdx = idx
      console.log('Set Index', this.editorIdx)
    },
    editorChanged(idx) {
      this.editorIdx = idx
      let body = this.messageBody(idx)
      console.log('Editor changed', {
        id: idx,
        body: body,
      })
      this.setSelectedBiTemplateData({
        name: 'rangeMessage',
        value: {
          id: idx,
          value: body,
        },
      })
      if (body !== '') {
        this.$emit('edited')
      }
    },
    showCannedMessages(idx) {
      this.cannedMessages = []
      this.editorIdx = idx
      let found = this.ranges.find(
        (range) => parseInt(range.id) === parseInt(idx)
      )
      if (found) {
        this.cannedMessages = found.clipTexts
        console.log('Show Canned Messages', this.cannedMessages)
        this.isShowPrecanned = true
      }
    },
    setPrecanned(idx, text) {
      this.isShowPrecanned = false
      this.editorIdx = idx
      this.setSelectedBiTemplateData({
        name: 'rangeMessage',
        value: {
          id: idx,
          value: text.text,
        },
      })
      let editor = this.$refs[`zEditor-${idx}`]
      if (editor) {
        editor[0].setHTML(text.text)
      }
      console.log('Set Precanned', this.selectedBiTemplate)
      this.$forceUpdate()
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-column-label {
  font-weight: 600;
}
.custom-editor {
  position: relative;
  min-height: 250px;
  max-height: 250px;
  height: 250px;
  width: 100%;
}
.custom-canned-messages-icon {
  position: absolute;
  right: 25px;
  top: 10px;
  cursor: pointer;
  text-align: right;
  i {
    font-size: 1.2em;
    color: #0d6efd;
  }
}
.custom-canned-messages-close {
  height: 25px;
  width: 100%;
  text-align: right;
  border-bottom: 1px solid #ced4da;
  i {
    font-size: 1.1em;
    color: #000;
  }
}
.custom-canned-messages {
  position: absolute;
  right: 16px;
  top: 5px;
  width: 550px;
  height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 3px;
  padding: 5px;
  -webkit-box-shadow: 0px 10px 17px -6px rgba(0, 0, 0, 0.18);
  -moz-box-shadow: 0px 10px 17px -6px rgba(0, 0, 0, 0.18);
  box-shadow: 0px 10px 17px -6px rgba(0, 0, 0, 0.18);
}
.custom-canned-messages-list {
  margin: 0;
  padding: 0;
  margin-top: 5px;
  li {
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  li:not(:last-child) {
    border-bottom: 1px solid #ced4da;
  }
  li:hover {
    background-color: #9ac2ff;
    color: #000;
  }
}
</style>
